import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { SectionHeading } from "@/components/marketing/SectionHeading";
import { HeroFilm } from "@/components/marketing/HeroFilm";

const POINTS = [
  ["Ask in your own words", "Type a question the way you would ask your general manager."],
  ["Answers from your live data", "ARI reads across your rota, workforce, compliance and finance, and shows the figures behind its answer."],
  ["You stay in control", "ARI suggests the next step and only acts when you confirm."],
];

export const AriConversationSection = () => {
  const { t } = useLang();
  return (
    <section className="relative max-w-7xl mx-auto px-4 sm:px-8 py-16 sm:py-24" data-testid="ari-conversation-section">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-5">
          <SectionHeading testId="ari-conversation-heading" eyebrow="ARI conversation" lead="Ask ARI anything." accent="Get the answer, with the numbers." />
          <ul className="mt-8 space-y-5">
            {POINTS.map(([h, d], i) => (
              <motion.li key={h} className="flex gap-4" initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.7, delay: 0.1 * i }}>
                <span className="mt-2 h-px w-6 shrink-0 bg-[#D4AF37]" />
                <span>
                  <span className="block text-[15px] text-[#F5EFE2]">{t(h)}</span>
                  <span className="block text-[13.5px] text-white/60 leading-relaxed mt-1">{t(d)}</span>
                </span>
              </motion.li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-7 relative">
          <HeroFilm />
        </div>
      </div>
    </section>
  );
};

export default AriConversationSection;
